<template>
  <div></div>
</template>

<script>
export default {
  name: `Registration`
};
</script>

<style scoped>

</style>
